import styled from "styled-components"

export const H1 = styled.h1`
  font-size: 60px;
`
export const H2 = styled.h2`
  font-size: 40px;
`
export const H3 = styled.h3`
  font-size: 30px;
`
export const H4 = styled.h4`
  font-size: 20px;
`
export const Paragraph = styled.p`
  font-size: 17px;
`
